module.exports = __webpack_public_path__ + "img/3.0b6099e9.png";